import { Grid } from '@material-ui/core';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAllAsync,
  selectStatus,
  selectModelosFollowUp,
} from '../../features/modelo-follow-up/modeloFollowUpSlice';
import QCXSimpleSelectOnePageTemplate from '../../templates/simple-select-one-page/QCXSimpleSelectOnePageTemplate';
import { isAlternativeLoadingStatus } from '../../utils/store/store-utils';

export default function QCXSelectOneModeloFollowUpTable({ ...props }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const status = useSelector(selectStatus);
  const modelosFollowUp = useSelector(selectModelosFollowUp);
  const modelosFollowUpActive = modelosFollowUp.filter((modelofollowup) => modelofollowup.active === true);

  const isAlternativeLoading = useMemo(() => (
    isAlternativeLoadingStatus(status)
  ), [status]);

  useEffect(() => {
    dispatch(fetchAllAsync());
  }, []);

  const filterProps = [
    'id',
    'description',
  ];

  const {
    title = t('com.muralis.qcx.modeloFollowUp.selecioneModeloFollowUp'),
    filterProp = 'description',
    columns = [
      {
        field: 'id',
        headerName: t('com.muralis.qcx.codigo'),
        headerAlign: 'center',
        align: 'center',
        flex: 50,
      },
      {
        field: 'description', headerName: t('com.muralis.qcx.modeloFollowUp.label'), flex: 300,
      },
      {
        field: 'active', headerName: t('com.muralis.qcx.estado.ativo'), type: 'boolean', flex: 50,
      },
    ],
    selected = null,
    handleChange,
    isConsult,
    ...restProps
  } = props;

  return (
    <>
      <Grid container direction="row" style={{ marginTop: '0.7rem' }}>
        <QCXSimpleSelectOnePageTemplate
          title={title}
          tableColumns={columns}
          tableData={modelosFollowUpActive}
          filterProp={filterProp}
          isLoading={isAlternativeLoading}
          isConsult={isConsult}
          handleSetSelected={handleChange}
          selected={selected}
          multipleFilter
          filterProps={filterProps}
          {...restProps}
        />
      </Grid>
    </>
  );
}
